import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IntuitiveToothForDiagram, IntuitiveIndication } from '../../models';
import { RxIntuitiveIndicationRulesService } from '@modules/rx-intuitive-teeth-diagram/services/rx-intuitive-indication-rules.service';

@Component({
	selector: 'rx-intuitive-tooth',
	templateUrl: './rx-intuitive-tooth.component.html',
	styleUrls: ['./rx-intuitive-tooth.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule],
	host: {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'[class]': 'indicationHostClass',
		'[class.rx-intuitive-tooth]': 'true',
		'[class.tooth--first-selected]': 'isFirstSelected',
		'[class.tooth--edit-mode]': 'isEditMode',
		'[class.tooth--assigned]': 'isAssigned',
		'[class.tooth--disabled]': 'isToothDisabled',
		'[class.bridge]': 'isBridge',
		'[class.bridge--outer-left]': 'isBridgeOuterLeft',
		'[class.bridge--outer-right]': 'isBridgeOuterRight',
		'[class.tooth--invalid]': 'isInvalidBridgeTooth || isInvalidForSend'
	}
})
export class RxIntuitiveToothComponent {
	@Input() tooth!: IntuitiveToothForDiagram;
	@Input() displayNumber!: string | number;
	@Input() symbolId!: string;
	@Input() numberPosition: 'above' | 'below' = 'below';
	@Input() chartReadOnly = false;

	@Output() toothClicked = new EventEmitter<number>();

	get isFirstSelected(): boolean {
		return !!this.tooth.isSelected && this.tooth.indicationId === this.indicationsService.getDefaultIndication();
	}

	get isEditMode(): boolean {
		return !!this.tooth.isSelected && this.tooth.indicationId !== this.indicationsService.getDefaultIndication();
	}

	get isAssigned(): boolean {
		return !this.tooth.isSelected && this.tooth.indicationId !== this.indicationsService.getDefaultIndication();
	}

	get isToothDisabled(): boolean {
		return !!this.tooth?.isDisabled;
	}

	get indicationHostClass(): string {
		return IntuitiveIndication[this.tooth.indicationId];
	}

	get isBridge(): boolean {
		return this.tooth.bridge != null;
	}

	get isBridgeOuterLeft(): boolean {
		return this.tooth.bridge?.isOuterLeft === true;
	}

	get isBridgeOuterRight(): boolean {
		return this.tooth.bridge?.isOuterRight === true;
	}

	get isInvalidBridgeTooth(): boolean {
		return this.tooth.isInvalid === true;
	}

	get isInvalidForSend(): boolean {
		return this.tooth.isInvalidForSend === true;
	}

	constructor(private readonly indicationsService: RxIntuitiveIndicationRulesService) {}

	onToothClick(): void {
		if (this.chartReadOnly || this.isToothDisabled || this.tooth?.toothId == null) {
			return;
		}

		this.toothClicked.emit(this.tooth.toothId);
	}
}
